import React, { useEffect } from 'react';
// import profilePic from "../assets/img/prepseed-media.png"
import RoundedBtn from './Common/RoundedBtn';
import Chats from './Chats';
import Mainfilter from './Mainfilter';
import { IoIosChatbubbles } from 'react-icons/io';
import { MdPeopleAlt, MdPersonAddAlt1 } from 'react-icons/md';
import { IoIosPeople } from 'react-icons/io';
import { HiDotsVertical } from 'react-icons/hi';
import { RxCross2 } from 'react-icons/rx';
import { pp } from '../assets/whatsapp';
import { BiFilter } from 'react-icons/bi';
import { BiFlag } from 'react-icons/bi';
import { FiFilter } from 'react-icons/fi';
import { useState } from 'react';
import '../styles/leftMenu.css';
import { useContext } from 'react';
import filterContext from '../context/filters/filterContext';
import {
	Button,
	Input,
	Modal,
	Checkbox,
	Tooltip,
	Dropdown,
	Menu,
} from 'antd/lib';
import { AlertFilled, DownOutlined } from '@ant-design/icons';
import Chat from './Chat';
import Loader from './Common/Loader';
import { AiOutlinePaperClip } from 'react-icons/ai';
import { RiAdminFill } from 'react-icons/ri';
import { useRef } from 'react';

import { useSelector } from 'react-redux';
import convertS3ToCloudFront from '../../../../../utils/convertS3ToCloudFront';
function LeftMenu() {
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [broadcastModal, setBroadcastModal] = useState(false);
	const [filterModal, setFilterModal] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [selectAll, setSelectAll] = useState(false);
	const [filteredConversations, setFilteredConversations] = useState([]);
	const [filteredUsers, setFilteredUsers] = useState([]);
	const [allUsersModal, setAllUsersModal] = useState(false);
	const [selectUserModal, setSelectUserModal] = useState(false);
	const [usersModalForGroups, setUsersModalForGroups] = useState(false);
	const [createGrpModal, setCreateGrpModal] = useState(false);
	const [makeAdminModal, setMakeAdminModal] = useState(false);

	const { logoDark } = window.config;

	// use state for e showing the filters on the left side of prepkey Whatsapp
	const {
		tog,
		settog,
		conversationdata,
		selectedConversations,
		setSelectedConversations,
		handleBroadcast,
		broadcastMsg,
		setBroadcastMsg,
		handleCustomFilter,
		customFilterName,
		setCustomFilterName,
		customFilterShortName,
		setCustomFilterShortName,
		filter,
		setfilter,
		settogFlag,
		fetchConversation,
		allUsers,
		getUsers,
		isLoading1,
		selectedUsers,
		setSelectedUsers,
		setGroupName,
		setGroupDesc,
		groupDesc,
		groupName,
		createGroup,
		broadurls,
		setBroadurls,
		addUsersToMultipleGroup,
		selectedUser,
		setSelectedUser,
		makeAdminInMultipleGrps,
		createOneOnOneChat,
		getCustomFilters,
	} = useContext(filterContext);
	const [selectedFilesBroad, setSelectedFilesBroad] = useState([]);
	const [broadcastMsgFor, setBroadcastMsgFor] = useState('');

	const [rf, setrf] = useState(false);
	const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
	//function for toggling between showing the filter and hiding the filters
	var arrOfMediaUrls = [];
	const handletoggle = event => {
		getCustomFilters();
		settog(current => !current);
	};
	const fileInputRef = useRef(null);

	const handleBroadcastMedia = () => {
		// Trigger the click event on the input element
		if (fileInputRef.current) {
			fileInputRef.current.click();
		}
	};
	const handleFileSelectBroadcast = async event => {
		const files = Array.from(event.target.files);
		setSelectedFilesBroad(files);
		for (const file of files) {
			// console.log(file);
			let filenamee = file.name;
			let typeOfFile = file.type;
			let filename = filenamee;
			let mime = typeOfFile.split('/')[1];
			// console.log(filename);
			const requestBody = {
				fileName: filename,
				mime: mime,
			};
			const response = await fetch(`${apiBaseUrl}/chats/uploadPolicy`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					authorization: `Token ${window.localStorage.getItem('token')}`,
				},
				body: JSON.stringify(requestBody),
			});
			const data = await response.json();
			// console.log(data.data.fields);
			const formData = new FormData();
			
			// Set Content-Type to ensure it matches S3 policy requirements
			const contentType = file.type || 'image/jpeg';
			
			for (const [key, value] of Object.entries(data.data.fields)) {
				// Override Content-Type if present to ensure exact match
				if (key.toLowerCase() === 'content-type') {
					formData.set(key, contentType);
				} else {
					formData.set(key, value);
				}
			}

			// Ensure Content-Type is set even if not in fields
			if (!formData.has('Content-Type') && !formData.has('content-type')) {
				formData.set('Content-Type', contentType);
			}
			
			formData.append('file', file);
			// console.log(formData);
			const finalurl = convertS3ToCloudFront(
				`${data.data.url}/${data.filePath}`,
			);
			arrOfMediaUrls.push(finalurl);
			// console.log(finalurl);
			try {
				const almostFinalResponse = await fetch(data.data.url, {
					method: 'POST',
					body: formData,
				});

				if (almostFinalResponse.ok) {
					console.log('File uploaded successfully.');
				} else {
					console.log(
						'Error occurred:',
						almostFinalResponse.status,
						almostFinalResponse.statusText
					);
				}
				setBroadurls(arrOfMediaUrls);
			} catch (error) {
				console.log('Error occurred:', error);
			}
		}
	};

	//useeffect for search functionality
	useEffect(() => {
		if (
			allUsersModal ||
			usersModalForGroups ||
			makeAdminModal ||
			selectUserModal
		) {
			const debounceSearch = setTimeout(() => {
				const lowerCaseQuery = searchQuery.toLowerCase();
				const filteredUsers = allUsers.filter(user =>
					user.name.toLowerCase().includes(lowerCaseQuery)
				);
				setFilteredUsers(filteredUsers);
			}, 300);
			return () => {
				clearTimeout(debounceSearch);
			};
		} else {
			const debounceSearch = setTimeout(() => {
				const lowerCaseQuery = searchQuery.toLowerCase();
				if (conversationdata != undefined) {
					const filteredConversations = conversationdata.filter(chat =>
						chat.name.toLowerCase().includes(lowerCaseQuery)
					);
					setFilteredConversations(filteredConversations);
				}
			}, 300);
			return () => {
				clearTimeout(debounceSearch);
			};
		}
	}, [searchQuery, conversationdata, allUsers]);

	const handleInputChange = e => {
		setSearchQuery(e.target.value);
	};

	const handleButtonClick = () => {
		setIsModalVisible(true);
	};

	const handleallUsersModal = () => {
		setFilteredUsers(allUsers);
		setAllUsersModal(true);
	};

	const handleCancel = () => {
		setSelectedConversations([]);
		setSelectedUsers([]);
		setBroadcastMsg('');
		setCustomFilterName('');
		setCustomFilterShortName('');
		setSelectAll(false);
		setIsModalVisible(false);
		setBroadcastModal(false);
		setFilterModal(false);
		setAllUsersModal(false);
		setCreateGrpModal(false);
		setUsersModalForGroups(false);
		setMakeAdminModal(false);
		setSelectUserModal(false);
		setSearchQuery('');
		setGroupName('');
		setGroupDesc('');
		setSelectedUser('');
		setBroadcastMsgFor('');
	};

	const handleOk = () => {
		setIsModalVisible(false);
		setBroadcastModal(true);
	};

	const handleOk1 = () => {
		setIsModalVisible(false);
		setFilterModal(true);
	};

	const handleOk2 = () => {
		setAllUsersModal(false);
		setCreateGrpModal(true);
	};

	const handleCancel1 = () => {
		if (filterModal == true || broadcastModal == true) {
			setFilterModal(false);
			setBroadcastModal(false);
			setIsModalVisible(true);
			setAllUsersModal(false);
		} else {
			setCreateGrpModal(false);
			setAllUsersModal(true);
			setGroupName('');
			setGroupDesc('');
		}
		setSearchQuery('');
	};

	const handleUserSelect = userId => {
		if (allUsersModal) {
			if (selectedUsers.includes(userId)) {
				const users = selectedUsers.filter(id => id !== userId);
				setSelectedUsers(users);
				setFilteredUsers(allUsers.filter(user => !users.includes(user._id)));
			} else {
				setSelectedUsers([...selectedUsers, userId]);
				const filtered = filteredUsers.filter(user => !user._id.includes(userId));
				setFilteredUsers(filtered);
			}
		} else if (isModalVisible) {
			if (selectedConversations.includes(userId)) {
				setSelectedConversations(selectedConversations.filter(id => id !== userId));
			} else {
				setSelectedConversations([...selectedConversations, userId]);
			}
		} else {
			if (selectedUsers.includes(userId)) {
				setSelectedUsers(selectedUsers.filter(id => id !== userId));
			} else {
				setSelectedUsers([...selectedUsers, userId]);
			}
		}
	};

	//The following function specifies the userSelection based on one-one chat
	const handleUsrSelect = (userId, name) => {
		setGroupName(name);
		// if (allUsersModal) {
		if (selectedUsers.includes(userId)) {
			setSelectedUsers([userId]);
			setFilteredUsers(allUsers.filter(user => user._id === userId));
		} else {
			setSelectedUsers([userId]);
			setFilteredUsers(allUsers.filter(user => user._id === userId));
		}
		//   }
	};
	const handleSelectAll = () => {
		if (isModalVisible) {
			if (selectAll) {
				setSelectedConversations([]);
			} else {
				const allConvIds = filteredConversations.map(chat => chat._id);
				setSelectedConversations(allConvIds);
			}
			setSelectAll(!selectAll);
		} else {
			if (selectAll) {
				setSelectedUsers([]);
			} else {
				const allUserIds = filteredUsers.map(user => user._id);
				setSelectedUsers(allUserIds);
			}
			setSelectAll(!selectAll);
		}
	};

	const handleBroadcastMsg = e => {
		setBroadcastMsg(e.target.value);
	};

	const handleCustomFilterName = e => {
		setCustomFilterName(e.target.value);
	};

	const handleCustomFilterShortName = e => {
		setCustomFilterShortName(e.target.value);
	};

	const handleGroupName = e => {
		setGroupName(e.target.value);
	};

	const handleGroupDesc = e => {
		setGroupDesc(e.target.value);
	};
	const broadcastMedia = () => {
		// document.querySelector(".broadcastMediainput input[type=file]").click();
		alert('clicked');
	};
	const redFlag = () => {
		setrf(curr => !curr);
	};
	const menu = (
		<Menu>
			<Menu.Item
				key="1"
				onClick={() => {
					setBroadcastMsgFor('All');
				}}
			>
				All
			</Menu.Item>
			<Menu.Item
				key="2"
				onClick={() => {
					setBroadcastMsgFor('Students');
				}}
			>
				Students
			</Menu.Item>
			<Menu.Item
				key="3"
				onClick={() => {
					setBroadcastMsgFor('Parents');
				}}
			>
				Parents
			</Menu.Item>
		</Menu>
	);
	const userSelector = state => state.user;
	const user = useSelector(userSelector);

	return (
		<div className="leftMenu-container">
			{/* Profile nav */}
			<div className="profile-navbar">
				{/* profile picture */}
				<img className="profile-pic" src={user.dp} alt="profile pic of the user" />
				{/* Profile nav buttons */}
				{user.role != 'user' && user.role != 'parent' && (
					<div className="profile-nav-btns">
						{/* {(window.config.clientId == '65d87f80e92e6e1e90072d2d' ||
							window.config.clientId == '66961d2dadeb874256026fcd') && (
							// <RoundedBtn
							// 	icon={<IoIosChatbubbles />}
							// 	tooltip="ONE to ONE Chat"
							// 	onClick={() => {
							// 		setSelectUserModal(true);
							// 		setSearchQuery('');
							// 		if (allUsers.length === 0) {
							// 			getUsers();
							// 		}
							// 		//This logic takes care of displaying users that we havent chatted yet
							// 		let usrs = allUsers.filter(usr => {
							// 			return !conversationdata.some(ele =>
							// 				ele.users.some(user => user.user?._id === usr._id)
							// 			);
							// 		});
							// 		setFilteredUsers(usrs);
							// 	}}
							// />
						)} */}
						{/* <RoundedBtn
							icon={<RiAdminFill />}
							tooltip="Make Admin in multiple groups"
							onClick={() => {
								setMakeAdminModal(true);
								setFilteredUsers(allUsers);
								setSearchQuery('');
								if (allUsers.length === 0) {
									getUsers();
								}
								setFilteredUsers(allUsers);
							}}
						/>
						<RoundedBtn
							icon={<MdPersonAddAlt1 />}
							tooltip="Add Participants to Multiple Groups"
							onClick={() => {
								setUsersModalForGroups(true);
								setFilteredUsers(allUsers);
								setSearchQuery('');
								if (allUsers.length === 0) {
									getUsers();
								}
							}}
						/>
						<RoundedBtn
							icon={<IoIosPeople />}
							tooltip="Broadcast or Create Shortcut"
							onClick={handleButtonClick}
						/>
						<RoundedBtn
							icon={<MdPeopleAlt />}
							tooltip="Create Group"
							onClick={() => {
								handleallUsersModal();
								setSearchQuery('');
								// if (allUsers.length === 0) {
								// 	getUsers();
								// }
							}}
						/>
						<RoundedBtn
							icon={<BiFlag style={{ color: 'red' }} />}
							tooltip="Red Flag"
							onClick={redFlag}
						/>
						<RoundedBtn
							icon={<FiFilter />}
							tooltip="Filters"
							onClick={handletoggle}
						/> */}
						{/* <RoundedBtn icon={<HiDotsVertical />} tooltip="Settings" /> */}
					</div>
				)}
			</div>
			<Modal
				title="Select Conversations"
				visible={isModalVisible}
				onCancel={handleCancel}
				footer={null}
				bodyStyle={{
					maxHeight: '550px',
					overflow: 'auto',
					paddingTop: '0',
					paddingBottom: '0',
				}}
			>
				<div className="edit-shortcut-modal">
					<div className="broadcast-modal">
						<div>
							<Input
								type="text"
								value={searchQuery}
								onChange={handleInputChange}
								placeholder="Search Conversations"
							/>
						</div>

						<div className="broadcast-input-bar">
							<Checkbox
								checked={selectAll}
								onChange={handleSelectAll}
								className="rounded-checkbox"
							/>
							<h6 className="contact-name">Select All</h6>
						</div>
					</div>

					{filteredConversations.map((chat, i) => {
						// if (chat.isGroup) {
						return (
							<div key={chat._id} className="modal-conversations">
								<Checkbox
									checked={selectedConversations.includes(chat._id)}
									onChange={() => handleUserSelect(chat._id)}
									className="rounded-checkbox"
									style={{ zIndex: '10' }}
								/>
								<img
									className="profile-pic"
									src={!chat.dp ? window.config.favicon : chat.dp}
									alt="profile pic"
								/>
								<h6 className="contact-name">{chat.name}</h6>
							</div>
						);
						// }	z
						// return null;
					})}
				</div>
				<div className="modal-btn">
					{selectedUser.length != 0 && (
						<>
							<Button
								onClick={() => {
									setMakeAdminModal(true);
									setIsModalVisible(false);
								}}
								className="modal-checkbox"
							>
								Back
							</Button>
							<Button
								type="primary"
								onClick={() => {
									makeAdminInMultipleGrps();
									setIsModalVisible(false);
								}}
								disabled={selectedConversations.length === 0}
							>
								Make Admin
							</Button>
						</>
					)}
					{selectedUsers.length == 0 && selectedUser.length == 0 && (
						<>
							<Button
								onClick={handleOk1}
								className="modal-checkbox"
								disabled={selectedConversations.length === 0}
							>
								Custom Filter
							</Button>
							<Button
								type="primary"
								onClick={handleOk}
								disabled={selectedConversations.length === 0}
							>
								Broadcast Message
							</Button>
						</>
					)}
					{selectedUsers.length != 0 && selectedUser.length == 0 && (
						<>
							<Button
								onClick={() => {
									setUsersModalForGroups(true);
									setIsModalVisible(false);
								}}
								className="modal-checkbox"
							>
								Back
							</Button>
							<Button
								type="primary"
								onClick={() => {
									addUsersToMultipleGroup();
									setIsModalVisible(false);
								}}
								disabled={selectedConversations.length === 0}
							>
								Add Participants
							</Button>
						</>
					)}
				</div>
			</Modal>
			<Modal
				title="Select User"
				visible={makeAdminModal}
				onCancel={handleCancel}
				footer={null}
				bodyStyle={{
					maxHeight: '550px',
					overflow: 'auto',
					paddingTop: '0',
					paddingBottom: '0',
				}}
			>
				<div className="edit-shortcut-modal">
					<div className="search-bar">
						<Input
							type="text"
							value={searchQuery}
							onChange={handleInputChange}
							placeholder="Search Users"
							className="modal-input-bar"
						/>
					</div>

					<div className="modal-users-container">
						{filteredUsers.length !== 0 ? (
							filteredUsers.map(user => {
								const isSelected = selectedUser.includes(user._id);
								if (user.role == 'mentor' || user.role == 'moderator') {
									return (
										<div
											key={user._id}
											onClick={() => setSelectedUser(user._id)}
											className={`modal-conversations`}
											style={{ backgroundColor: isSelected ? '#202d33' : '' }}
										>
											<img
												className="profile-pic"
												src={
													user.dp === ''
														? 'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/UKVqGegFg8.svg'
														: user.dp
												}
												alt="profile_picture"
											/>
											<h6 className="contact-name">{user.name}</h6>
										</div>
									);
								}
							})
						) : (
							<h5 className="no-users" style={{ color: 'white' }}>
								No Users Found
							</h5>
						)}
					</div>

					<div className="modal-btn-container">
						<Button onClick={handleCancel} style={{ marginRight: '20px' }}>
							Cancel
						</Button>
						<Button
							type="primary"
							disabled={selectedUser.length === 0}
							onClick={() => {
								setMakeAdminModal(false);
								setIsModalVisible(true);
								setSearchQuery('');
							}}
						>
							Select Conversations
						</Button>
					</div>
				</div>
			</Modal>
			<Modal
				title="Select Participants"
				visible={usersModalForGroups}
				onCancel={handleCancel}
				footer={null}
				bodyStyle={{
					maxHeight: '550px',
					overflow: 'auto',
					paddingTop: '0',
					paddingBottom: '0',
				}}
			>
				<div className="edit-shortcut-modal">
					<div className="broadcast-modal">
						<div>
							<Input
								type="text"
								value={searchQuery}
								onChange={handleInputChange}
								placeholder="Search Participants"
								className="modal-input-bar"
							/>
						</div>

						<div className="broadcast-input-bar">
							<Checkbox
								checked={selectAll}
								onChange={handleSelectAll}
								className="rounded-checkbox"
							/>
							<h6 className="contact-name">Select All</h6>
						</div>
					</div>

					{filteredUsers.length > 0 ? (
						filteredUsers.map((user, i) => {
							return (
								<div key={user._id} className="modal-conversations">
									<Checkbox
										checked={selectedUsers.includes(user._id)}
										onChange={() => handleUserSelect(user._id)}
										className="rounded-checkbox"
										style={{ zIndex: '10' }}
									/>
									<img
										className="profile-pic"
										src={user.dp === '' ? window.config.favicon : user.dp}
										alt="profile pic"
									/>
									<h6 className="contact-name">{user.name}</h6>
								</div>
							);
						})
					) : (
						<h5 className="no-users" style={{ color: 'white' }}>
							No Users Found
						</h5>
					)}
				</div>
				<div className="modal-btn">
					<Button
						type="primary"
						onClick={() => {
							setIsModalVisible(true);
							setUsersModalForGroups(false);
						}}
						disabled={selectedUsers.length === 0}
					>
						Select Groups
					</Button>
				</div>
			</Modal>
			<Modal
				title="Broadcast Message"
				visible={broadcastModal}
				onCancel={handleCancel}
				// onOk={handleOk1}
				footer={null}
				bodyStyle={{ paddingTop: '0', paddingBottom: '0' }}
			>
				<Dropdown overlay={menu} trigger={['click']}>
					<Button style={{ marginTop: 8 }}>
						{broadcastMsgFor !== '' ? broadcastMsgFor : 'Please Select'}{' '}
						<DownOutlined />
					</Button>
				</Dropdown>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<Input
						type="text"
						value={broadcastMsg}
						onChange={handleBroadcastMsg}
						placeholder="Write Your message"
						style={{
							width: '70%',
							marginRight: '25px',
						}}
					/>
					<Tooltip title="Send media">
						<button
							style={{
								borderRadius: '50%',
								padding: '8px',
								background: 'grey',
								border: 'none',
							}}
							onClick={handleBroadcastMedia}
						>
							<AiOutlinePaperClip size={16} style={{ color: 'black' }} />
						</button>
					</Tooltip>
					<input
						ref={fileInputRef}
						type="file"
						multiple
						style={{ display: 'none' }}
						onChange={handleFileSelectBroadcast}
					/>
				</div>
				<div className="modal-btn">
					<Button onClick={handleCancel1} className="modal-checkbox">
						Back
					</Button>
					<Button
						type="primary"
						onClick={() => {
							handleBroadcast(broadurls, broadcastMsgFor);
							setBroadcastModal(false);
							setBroadcastMsgFor('');
						}}
						// disabled={broadcastMsg.length === 0}
					>
						Send
					</Button>
				</div>
			</Modal>
			<Modal
				title="Create Shortcut"
				visible={filterModal}
				onCancel={handleCancel}
				footer={null}
				bodyStyle={{ paddingTop: '0', paddingBottom: '0' }}
			>
				<Input
					type="text"
					value={customFilterName}
					onChange={handleCustomFilterName}
					placeholder="Filter Name"
					className="modal-input-bar"
				/>

				<Input
					type="text"
					value={customFilterShortName}
					onChange={handleCustomFilterShortName}
					placeholder="Short Name"
				/>

				<div className="modal-btn">
					<Button onClick={handleCancel1} className="modal-checkbox">
						Back
					</Button>
					<Button
						type="primary"
						onClick={() => {
							handleCustomFilter();
							setFilterModal(false);
						}}
						disabled={
							customFilterName.length === 0 || customFilterShortName.length === 0
						}
					>
						Create
					</Button>
				</div>
			</Modal>
			<Modal
				title="Add Group participants"
				visible={allUsersModal}
				onCancel={handleCancel}
				footer={null}
				bodyStyle={{
					maxHeight: '550px',
					overflow: 'auto',
					paddingTop: '0',
					paddingBottom: '0',
				}}
			>
				<div className="edit-shortcut-modal">
					<div>
						<Input
							type="text"
							value={searchQuery}
							onChange={handleInputChange}
							placeholder="Search Users"
							className="modal-input-bar"
						/>
					</div>

					{selectedUsers.length > 0 && (
						<div
							style={{
								display: 'flex',
								flexWrap: 'wrap',
								gap: '15px',
								overflow: 'auto',
								maxHeight: '100px',
							}}
						>
							{allUsers
								.filter(user => selectedUsers.includes(user._id))
								.map(user => {
									return (
										<div
											style={{
												display: 'flex',
												gap: '5px',
												backgroundColor: '#808080',
												borderRadius: '15px',
												alignItems: 'center',
											}}
										>
											<div
												style={{
													height: '25px',
													width: '25px',
													borderRadius: '50%',
													backgroundColor: '#666666',
												}}
											>
												<img
													src={
														user.dp === ''
															? 'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/UKVqGegFg8.svg'
															: user.dp
													}
													alt="profile_picture"
												/>
											</div>
											<div style={{ fontSize: '15px' }}>{user.name}</div>
											<div
												className="cross-btn"
												style={{
													fontSize: '15px',
													height: '25px',
													width: '25px',
													borderRadius: '50%',
													textAlign: 'center',
												}}
												onClick={() => handleUserSelect(user._id)}
											>
												<RxCross2 />
											</div>
										</div>
									);
								})}
						</div>
					)}

					<div className="modal-users-container">
						{filteredUsers.length !== 0 ? (
							filteredUsers.map(user => {
								// const isSelected = selectedUser.includes(user._id);
								return (
									<div
										key={user._id}
										onClick={() => handleUserSelect(user._id)}
										className={`all-modal-conversations`}
										// style={{ backgroundColor: isSelected ? '#202d33' : '' }}
									>
										<img
											className="profile-pic"
											src={
												user.dp === ''
													? 'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/UKVqGegFg8.svg'
													: user.dp
											}
											alt="profile_picture"
										/>
										<h6 className="contact-name">{user.name}</h6>
									</div>
								);
							})
						) : isLoading1 === true ? (
							<h5 className="no-users">
								<Loader />
							</h5>
						) : (
							<h5 className="no-users" style={{ color: 'white' }}>
								No Users Found
							</h5>
						)}
					</div>
				</div>
				<div className="modal-btn-container">
					<Button onClick={handleCancel} className="modal-checkbox">
						Cancel
					</Button>
					<Button
						type="primary"
						onClick={handleOk2}
						disabled={selectedUsers.length === 0}
					>
						Create Group
					</Button>
				</div>
			</Modal>
			{/* select specific user (one-one chats) */}
			<Modal
				title="Select A User To Chat With"
				visible={selectUserModal}
				onCancel={handleCancel}
				footer={null}
				bodyStyle={{
					maxHeight: '550px',
					overflow: 'auto',
					paddingTop: '0',
					paddingBottom: '0',
				}}
			>
				<div className="edit-shortcut-modal">
					<div>
						<Input
							type="text"
							value={searchQuery}
							onChange={handleInputChange}
							placeholder="Search Users"
							className="modal-input-bar"
						/>
					</div>

					{/* {selectedUsers.length > 0 && (
						<div
							style={{
								display: 'flex',
								flexWrap: 'wrap',
								gap: '15px',
								overflow: 'auto',
								maxHeight: '100px',
							}}
						>
							{allUsers
								.filter(user => selectedUsers.includes(user._id))
								.map(user => {
									return (
										<div
											style={{
												display: 'flex',
												gap: '5px',
												backgroundColor: '#808080',
												borderRadius: '15px',
												alignItems: 'center',
											}}
										>
											<div
												style={{
													height: '25px',
													width: '25px',
													borderRadius: '50%',
													backgroundColor: '#666666',
												}}
											>
												<img
													src={
														user.dp === ''
															? 'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/UKVqGegFg8.svg'
															: user.dp
													}
													alt="profile_picture"
												/>
											</div>
											<div style={{ fontSize: '15px' }}>{user.name}</div>
											<div
												className="cross-btn"
												style={{
													fontSize: '15px',
													height: '25px',
													width: '25px',
													borderRadius: '50%',
													textAlign: 'center',
												}}
												onClick={() => handleUserSelect(user._id)}
											>
												<RxCross2 />
											</div>
										</div>
									);
								})}
						</div>
					)} */}

					<div className="modal-users-container">
						{filteredUsers.length !== 0 ? (
							filteredUsers.map(user => {
								// const isSelected = selectedUser.includes(user._id);
								return (
									<div
										key={user._id}
										onClick={() => handleUsrSelect(user._id, user.name)}
										className={`all-modal-conversations`}
										// style={{ backgroundColor: isSelected ? '#202d33' : '' }}
									>
										<img
											className="profile-pic"
											src={
												user.dp === ''
													? 'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/UKVqGegFg8.svg'
													: user.dp
											}
											alt="profile_picture"
										/>
										<h6 className="contact-name">{user.name}</h6>
									</div>
								);
							})
						) : isLoading1 === true ? (
							<h5 className="no-users">
								<Loader />
							</h5>
						) : (
							<h5 className="no-users" style={{ color: 'white' }}>
								No Users Found
							</h5>
						)}
					</div>
				</div>
				<div className="modal-btn-container">
					<Button onClick={handleCancel} className="modal-checkbox">
						Cancel
					</Button>
					<Button
						type="primary"
						onClick={() => {
							handleCancel();
							createOneOnOneChat();
						}}
						disabled={selectedUsers.length === 0}
					>
						Start Chatting
					</Button>
				</div>
			</Modal>
			<Modal
				title="Create Group"
				visible={createGrpModal}
				onCancel={handleCancel}
				footer={null}
				bodyStyle={{ paddingTop: '0', paddingBottom: '0' }}
			>
				<Input
					type="text"
					value={groupName}
					onChange={handleGroupName}
					placeholder="Group Name"
					className="modal-input-bar"
				/>

				<Input
					type="text"
					value={groupDesc}
					onChange={handleGroupDesc}
					placeholder="Group Description"
				/>

				<div className="modal-btn">
					<Button onClick={handleCancel1} className="modal-checkbox">
						Back
					</Button>
					<Button
						type="primary"
						onClick={() => {
							createGroup();
							setCreateGrpModal(false);
						}}
						disabled={groupName.trim() == '' || groupDesc.trim() == ''}
					>
						Create
					</Button>
				</div>
			</Modal>
			{tog && <Chats rf={rf} />}
			{!tog && <Mainfilter />}
		</div>
	);
}

export default LeftMenu;
